<template>
  <email-schedule-form/>
</template>
<script>
import EmailScheduleForm from '@/views/admin/settings/Email/EmailScheduleForm'
export default {
  components: {
    EmailScheduleForm
  },
}
</script>
<style>
</style>
